<template>
<div class="selectBC">
  <div v-if="isShow" class="">
    <Flow v-bind:step="1"/>
    <div class="contents bg_white mt12 pt16">
      <h2 class="content_title">BC選択</h2>
      <form class="form" action="" method="post">
        <div class="select_wrap">
          <select class="select_bc rb" name="bc_number" v-model="nowBC">
            <option v-for="index in bcList" v-bind:value="index" :key="index">{{ index }}</option>
          </select>
        </div>
        <div class="mt16 notice_credit">
          <p class="rb notice_credit__title">■クレジットカード払いをご利用の場合</p>
          <p class="rr">クレジットカードのご登録は、マイページから</p>
          <p class="rr">お手続きください</p>
        </div>
        <a href="#" class="btn_blue" @click.stop.prevent="setBC()">次へ</a>
        <!-- <router-link class="btn_blue" :to="{ name: 'SelectProducts', query: {bc: this.nowBC } }" v-on:click.native="setBC()">次へ</router-link> -->
      </form>
      <button type="button" name="button" onClick="android.close()" @click="closeWebView()" class="back btn_delete">戻る</button>
    </div>
  </div>
  <div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
</div>
</template>

<script>
import Flow from '@/components/purchase/Flow'
import Bc from '@/components/api/bc'

import Check from '@/model/getToken'
import Member from '@/components/api/memberInfo'
import close from '@/model/closeWebView'

export default {
  components: {
    Flow
  },
  data() {
    return {
      isShow: true,
      bcList: [],
      nowBC: '',
      selectBC: []
    }
  },
  methods: {
    closeWebView() {
      close.closeWebView();
      // console.log('close');
      // webkit.messageHandlers.jsCallbackHandler.postMessage("close");
    },
    setPurchaseNowBC(bc) {
      this.$store.commit('setPurchaseNowBC', bc);
    },
    setPurchaseCartBC(bc) {
      this.$store.commit('setPurchaseCartBC', bc);
    },
    async defaultBC() {
      Bc.bcList().then((val) => {
        for (var i = 0; i < val.bcNoList.length; i++) {
          this.bcList.push(val.bcNoList[i]);
        }
        this.setNowBC();
      });
    },
    setBC() {
      if(this.nowBC == '')  return;
      this.setPurchaseNowBC(this.nowBC);
      this.setPurchaseCartBC(this.nowBC);
      let checkedBC = [];
      let BC = JSON.parse(localStorage.getItem('selectBC'));
      if(BC != null && BC.length != 0) {
        for (var i = 0; i < BC.length; i++) {
          this.selectBC.push(BC[i]);
        }
        this.selectBC.push(this.nowBC);
      }else {
        this.selectBC.push(this.nowBC);
      }
      // 重複削除
      this.selectBC = this.selectBC.filter(function (x, i, self) {
        return self.indexOf(x) === i;
      });

      this.selectBC.sort();
      var removals = ['', null];
      this.selectBC = this.selectBC.filter(function(v){
        return ! removals.includes(v);
      });
      localStorage.setItem('selectBC', JSON.stringify(this.selectBC)); // JSONに変換
      localStorage.setItem('nowBC', this.nowBC);

      this.$router.push({ name: 'SelectProducts', query: {bc: this.nowBC }});
    },
    setNowBC() {
      let nowBC = localStorage.getItem('nowBC');
      if(nowBC != null) {
        this.nowBC = nowBC;
      } else {
        this.nowBC = this.bcList[0];
      }
      this.setPurchaseNowBC(this.nowBC);
      this.setPurchaseCartBC(this.nowBC);
    },
    apiGetMemberInfo() {
      Member.getMemberInfo().then((val) => {
        console.log(val);
        this.checkMemberId(val.memberInfo.memberId);
        if(val) {
          localStorage.setItem('memberId', val.memberInfo.memberId);
        }

      });
    },
    checkMemberId(memberId) {
      let strageMemberId = localStorage.getItem('memberId');
      console.log('APIから受け取った値' + memberId);
      console.log('ストレージ ' + strageMemberId);
      if(strageMemberId != memberId) {
        console.log('違う');
        // ストレージリセット
        localStorage.removeItem('userDetail');
        localStorage.removeItem('nowBC');
        let selectBC = JSON.parse(localStorage.getItem('selectBC'));
        if(selectBC) {
          for (var i = 0; i < selectBC.length; i++) {
            localStorage.removeItem(selectBC[i]);
          }
          localStorage.removeItem('selectBC');
        }
      }
    }
  },
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
      this.apiGetMemberInfo()
      this.defaultBC();

    } else {
      this.isShow = false;
    }
  }
}
</script>

<style lang="css" scoped>
.back {
  margin-top: 25px;
}
select {
  -webkit-appearance: none;
  appearance: none; /* デフォルトのスタイルを無効 */
}

select::-ms-expand {
  display: none; /* デフォルトのスタイルを無効(IE用) */
}

.content_title {
  width: 94px;
}

.select_bc {
  border: none;
  border-bottom: 1px solid #c9c9c9;
  color: #5a5a5a;
  font-size: 40px;
  margin-top: 17px;
  padding: 0 16px 10px;
  width: 100%;
}

.select_wrap {
  position: relative;
}

.select_wrap::after {
  content: '\f078';
  color: #636366;
  font-size: 18px;
  font-family: "Font Awesome 5 Free","Font Awesome 5 Brands";
  font-weight: 900;
  margin-right: 4px;
  position: absolute;
  right: 17px;
  top: 59%;
}
.btn_blue {
  margin-top: 56px;
}
/* .btn_blue {
  margin-top: 56px;
} */

/* 追加: クレジットカード案内 表示調整 */
.notice_credit {
  text-align: center;
  color: #d60000; /* 赤 */
}

.notice_credit__title {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/views/purchase/SelectBC.vue